export class NotValidURLError extends Error {
  constructor() {
    super('Url have invalid value for redirect');
  }
}